import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';

let baseUrl = 'https://b316wmuwh1.execute-api.us-east-1.amazonaws.com/default/get_banco';
axios.defaults.headers.post['authorizationToken'] = '&S396b<eg5Zn(HiLe)BBNtc&';

class Banco extends Component {
    
    constructor() {
        super();
        this.state = {
            datos_banco: []
        };
    }
    async componentDidMount() {
        await axios.post(baseUrl,{id_campana: '807365f9-8c54-4074-a32f-eeba79502478'})
        .then(response => {
            //console.log('exito al enviar POST nacionalidad: ' + JSON.stringify(response.data));
            this.setState({datos_banco:response.data});
        })
        .catch(response => {
            console.log(response + ' error POST nacionalidad')
        })

    }
    render(){
        const { datos_banco } = this.state;
        let BancoList = datos_banco.length > 0
            && datos_banco.map((item, i) => {
                return (
                    <option key={item.num_id} value={item.num_id+'|'+item.name_bank}>{item.name_bank}</option>
                )
            }, this);
        return(
            <>
            {BancoList}
            </>
        )
    }
}
  
export default Banco; 
